// Exam category / status helpers. Catalog itself is fetched from the backend
// (single source of truth) via GET /api/exams/catalog.

export const CATEGORY_META = {
    laboratorial: { label: "Laboratoriais", color: "#1E3F33", accent: "#D4A574" },
    imagem: { label: "Imagem", color: "#8A6A15", accent: "#EBD7A8" },
    cardiovascular: { label: "Cardiovasculares", color: "#B33A3A", accent: "#F1C7C7" },
    corporal: { label: "Corporal / Metabólico", color: "#4A6B58", accent: "#C7DBCA" },
    molecular: { label: "Moleculares / Precisão", color: "#5B3F72", accent: "#DAC7EA" },
    neuro_funcional: { label: "Neuro / Funcional", color: "#2A5773", accent: "#C7DAE8" },
    endoscopico: { label: "Endoscópicos", color: "#7E4E1E", accent: "#EBD1B0" },
    outros: { label: "Outros", color: "#4B4B4B", accent: "#DDD" },
};

export const FLAG_META = {
    normal: { label: "Normal", color: "#1E3F33", bg: "#E5EEE7" },
    low: { label: "Baixo", color: "#8A6A15", bg: "#FBF4E5" },
    high: { label: "Alto", color: "#8A6A15", bg: "#FBF4E5" },
    critical: { label: "Crítico", color: "#B33A3A", bg: "#FBEEEE" },
};

export function fmtExamDate(iso) {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return iso;
        return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
    } catch { return iso; }
}

export function humanFileSize(bytes) {
    if (!bytes) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
